import gizmoStanding from '@images/gizmo-standing.png'
import Component from '@glimmer/component'

interface Signature {
  Element: HTMLImageElement
}

interface ImageData {
  src: string
  alt: string
}

/**
 * Intended for use in high-level application-error page where the subscription-type is not known
 */
export class ErrorsImageApplicationError extends Component<Signature> {
  get imageData(): ImageData {
    return {
      src: gizmoStanding,
      alt: 'gizmo',
    }
  }

  <template>
    <img
      data-test-application-error-image
      class="mx-auto"
      src={{this.imageData.src}}
      alt={{this.imageData.alt}}
      ...attributes
    />
  </template>
}
